import { Component } from '@verndale/core';
import Swiper, { Navigation, Keyboard } from 'swiper';
import 'swiper/css/bundle';
import { BREAKPOINTS } from '../helpers/breakpoints';
import { debounce } from '../helpers/debounce';
import { DataLayerObject, ExtendedWindowType } from '../helpers/global-types';

class ImageMastheadCarousel extends Component {
  private touch = false;

  constructor(el: HTMLElement) {
    super(el);
    this.initSwiper();
  }

  setupDefaults() {
    this.dom = {
      swiperContainer: this.el.querySelector<HTMLElement>('.swiper-container'),
      swiperWrapper: this.el.querySelector<HTMLElement>('.swiper-wrapper'),
      nextArrow: this.el.querySelector<HTMLElement>('.swiper-button-next'),
      prevArrow: this.el.querySelector<HTMLElement>('.swiper-button-prev')
    };

    document.documentElement.style.setProperty(
      '--image-masthead-block-size',
      `${this.el.offsetHeight}px`
    );
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.handleResize.bind(this), 250)
    );
  }

  swiperLayerEvent(swiper: Swiper) {
    const interactLayer = `{"event":"carousel_interaction","event_action":"${
      this.touch ? 'swipe' : 'arrow click'
    }","event_category":"content_interaction","event_label":"${(
      swiper.activeIndex + 1
    ).toString()} of ${swiper.slides.length}"}`;

    if (interactLayer) {
      (window as ExtendedWindowType).dataLayer.push(
        JSON.parse(interactLayer) as DataLayerObject
      );
    }
  }

  handleResize() {
    document.documentElement.style.setProperty(
      '--image-masthead-block-size',
      `${this.el.offsetHeight}px`
    );
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard]);

    new Swiper(this.dom.swiperContainer as HTMLElement, {
      spaceBetween: 10,
      slidesPerView: 1,
      navigation: {
        prevEl: this.dom.prevArrow as HTMLElement,
        nextEl: this.dom.nextArrow as HTMLElement
      },
      breakpoints: {
        [BREAKPOINTS.tablet]: {
          spaceBetween: 20
        },
        [BREAKPOINTS.tabletLandscape]: {
          spaceBetween: 28
        }
      },
      on: {
        slideChange: swiper => this.swiperLayerEvent(swiper),
        touchEnd: () => (this.touch = true),
        click: () => (this.touch = false)
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });
  }
}

export default ImageMastheadCarousel;
